import { useState} from 'react';
import { Modal, Row, Col, Button, Card, Form, Image } from 'react-bootstrap';
import api from './api/axiosInstance';
import icCalendar from './assets/img/ic-calendar.svg';
import icUser from './assets/img/ic-user-circle.svg';
import icDownload from './assets/img/ic-file-download.svg';
import icAdd from './assets/img/ic-add-circle.svg';
import icSucess from './assets/img/ic-celebration-circle.svg';


const TicketAddActivity = ({handleChange, formData, setFormData, ticketId, refreshTicket }) => {
    const [showAddActivityModal, setShowAddActivityModal] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [attachment, setAttachment] = useState(null);
    const [isPublic, setIsPublic] = useState(false);
    const [activityErrors, setActivityErrors] = useState({});
    const [activitySubmitError, setActivitySubmitError] = useState('');
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const baseUrl = process.env.REACT_APP_API_BASE_URL?.replace(/\/$/, '');

    const isImageAttachment = (filename) =>
        /\.(jpg|jpeg|png)$/i.test(filename || '');

    const handleDownload = async (url, filename) => {
        try {
            const res = await fetch(url);
            const blob = await res.blob();
            const blobUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = filename;
            a.click();
            URL.revokeObjectURL(blobUrl);
        } catch {
            window.open(url, '_blank');
        }
    };

    const handleNewActivityClick = () => {
        setActivitySubmitError('');
        setShowAddActivityModal(true);
    };

    const handleActivitySubmit = async (e) => {
        e.preventDefault();

        if (!formData.comment || formData.comment.trim() === '') {
            setActivityErrors({ comment: 'Comment is required.' });
            return;
        }
    
        const form = new FormData();
        form.append('comment', formData.comment);
        form.append('public', isPublic);
        if (attachment) form.append('attachments', attachment);
    
        try {
            const response = await api.put(
                `/api/tickets/${ticketId}/activity`,
                form
            );
    
            // ✅ Refresh ticket to get updatedBy and updatedAt
            if (refreshTicket) refreshTicket();
    
            // Clear UI state
            setFormData(prev => ({ ...prev, comment: '' }));
            setAttachment(null);
            setIsPublic(false);
            setShowAddActivityModal(false);
            setShowSuccessModal(true);
            console.log('Server message:', response.data.message);
        } catch (error) {
            console.error('Error saving activity:', error);
            setActivitySubmitError(
                error.response?.data?.error ||
                error.response?.data?.message ||
                error.message ||
                'Failed to save activity. Please try again.'
            );
        }
    };
        

    const formatDateTime = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // months are 0-based
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
      
        return `${day}.${month}.${year}. ${hours}:${minutes}`;
    };
    

    return (
        <>
            <Card className="mb-4">
                <Card.Body>
                    {/* Title and Edit Button */}
                    <Row className="align-items-center">
                        <Col>
                            <div className="float-end">
                                <Button variant="outline-secondary" onClick={handleNewActivityClick} className="btn-sm">Add New Activity</Button>
                            </div>
                            <h3 className="text-start">3. Activity</h3>
                            <hr />
                        </Col>
                    </Row>
                    <Row className="row-activity">
                        <Col md={12}>
                            {Array.isArray(formData.activity) && formData.activity.length > 0 ? (
                            [...formData.activity]
                                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                                .map((entry, index) => (
                                <Card className="mb-3 card-activity" key={index}>
                                    <Card.Body>
                                        <p className="mb-2">
                                            <Image className="me-1" src={icCalendar} alt="Activity formed at" />
                                            {formatDateTime(entry.createdAt)}
                                            <span className="dot"></span>
                                            <Image className="me-1" src={icUser} alt="Activity formed by" />
                                            <span>
                                                {entry.createdBy
                                                    ? `${entry.createdBy.firstName || ''} ${entry.createdBy.familyName || ''}`.trim() || 'Admin'
                                                    : 'Admin'}
                                            </span>
                                        </p>
                                        <h5>{entry.comment}</h5>
                                        {entry.attachments?.length > 0 && (
                                            <div className="d-flex flex-wrap gap-2 mt-2">
                                                {entry.attachments.map((a, aIdx) => {
                                                    const url = `${baseUrl}${a.url}`;
                                                    return isImageAttachment(a.url) ? (
                                                        <img
                                                            key={aIdx}
                                                            src={url}
                                                            alt={a.originalName}
                                                            onClick={() => setPreviewUrl(url)}
                                                            style={{ width: 56, height: 56, objectFit: 'cover', borderRadius: 6, border: '1px solid #c0d9ee', cursor: 'pointer', display: 'block' }}
                                                        />
                                                    ) : (
                                                        <button
                                                            key={aIdx}
                                                            onClick={() => handleDownload(url, a.originalName)}
                                                            className="d-inline-flex align-items-center gap-1 btn btn-link p-0"
                                                        >
                                                            <Image src={icDownload} alt="" />
                                                            <span style={{ fontSize: '1.2rem' }}>{a.originalName}</span>
                                                        </button>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </Card.Body>
                                </Card>
                                ))
                            ) : (
                                <p>No activities yet.</p>
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* Add Ticket Modal */}
            <Modal className="with-form" show={showAddActivityModal} onHide={() => setShowAddActivityModal(false)} centered>
                <Form onSubmit={handleActivitySubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title className="mb-3">Add new activity</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {activitySubmitError && (
                            <div className="alert alert-danger">{activitySubmitError}</div>
                        )}
                        <p className="mb-5">We need a short description here</p>
                        <Form.Group className="pt-1 mb-3"controlId="comment">
                            <Form.Label>Comment</Form.Label>
                            <Form.Control
                                as="textarea"
                                name="comment"
                                value={formData.comment || ''}
                                onChange={handleChange}
                                isInvalid={!!activityErrors.comment}
                                height="77"
                            />
                            <Form.Control.Feedback type="invalid">
                                {activityErrors.comment}
                            </Form.Control.Feedback>
                        </Form.Group>
                        
                        <Form.Group controlId="file">
                            <Form.Label>Upload documents</Form.Label>
                            <div 
                                className="custom-upload-box mb-1"
                                onClick={() => document.getElementById("hiddenFileInput").click()}
                            >
                                <Image className="upload-icon" src={icAdd} alt="Upload File" />
                                <span className="upload-text">Choose file</span>
                            </div>
                            <Form.Control
                                id="hiddenFileInput"
                                type="file"
                                name="attachment"
                                style={{ display: "none" }} // hide real input
                                onChange={(e) => setAttachment(e.target.files[0])}
                            />
                            <p className="info">
                                File format: PNG, JPG, PDF. Max file size: 5MB
                            </p>
                        </Form.Group>

                        <div className="visible-toggle d-flex align-items-center justify-content-between">
                            <p className="visible-toggle__label">Public <span>(Companies/Talents can see public ones)</span></p>

                            <div className="d-flex align-items-center gap-2">
                                <Form.Group controlId="publicSwitch">
                                    <Form.Check
                                        type="switch"
                                        id="public-switch"
                                        checked={isPublic}
                                        onChange={(e) => setIsPublic(e.target.checked)}
                                        className="visible-toggle__switch"
                                    />
                                </Form.Group>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button type="submit" variant="primary" onClick={handleActivitySubmit}>
                            Save
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* Success Modal */}
            <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Image
                        src={icSucess}
                        alt=""
                        className="d-block m-auto mb-4"
                    />
                    <h2 className="text-center mb-3">Activity successfully created</h2>
                    <p className="text-center">The activity has been successfully created in the system.</p>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center">
                    <Button variant="primary" onClick={() => setShowSuccessModal(false)}>
                        Go back to the ticket
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={!!previewUrl} onHide={() => setPreviewUrl(null)} centered size="lg">
                <Modal.Header closeButton />
                <Modal.Body className="text-center p-2">
                    <img
                        src={previewUrl}
                        alt="Preview"
                        style={{ maxWidth: '100%', maxHeight: '75vh', borderRadius: 6 }}
                    />
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <Button variant="outline-secondary" size="sm" onClick={() => handleDownload(previewUrl, previewUrl?.split('/').pop())}>
                        Download
                    </Button>
                </Modal.Footer>
            </Modal>

        </>
    );
};

export default TicketAddActivity;
